import React, { useCallback, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import {
    Assignment as AssignmentIcon,
    CalendarMonth as CalendarMonthIcon,
    CloudUpload as CloudUploadIcon,
    PictureAsPdf as PictureAsPdfIcon,
    AssignmentTurnedIn as AssignmentTurnedInIcon,
    PeopleAlt as PeopleAltIcon,
    SimCardDownload as SimCardDownloadIcon,
    CalendarToday as CalendarTodayIcon,
    LogoutRounded as LogoutRoundedIcon,
    ExpandCircleDown as ExpandCircleDownIcon,
    Quiz as QuizIcon
} from '@mui/icons-material';

import { setIsLeftBarExtended } from "../../../store/common/commonSlice";
import classes from "./styles.module.scss";
import "./active.css";
import { useGetPendingOrderCRMQuery } from "../../../store/common/commonApiSlice";

const LeftBar = () => {
    const dispatch = useDispatch();
    const isExtended = useSelector((state) => state.common.isLeftBarExtended);
    const { data } = useGetPendingOrderCRMQuery();
    const showPrepcaConnect = !data?.paymentPending;

    const handleExtendToggle = useCallback(() => {
        dispatch(setIsLeftBarExtended(!isExtended));
    }, [dispatch, isExtended]);

    const menuItems = useMemo(() => {
        return [
            { to: "/dashboard/question", label: "Question", icon: <AssignmentIcon /> },
            { to: "/dashboard/upload-answer", label: "Upload Answer", icon: <CloudUploadIcon /> },
            { to: "/dashboard/answer", label: "Answer", icon: <CalendarMonthIcon /> },
            { to: "/dashboard/evaluated", label: "Evaluated Answer", icon: <PictureAsPdfIcon /> },
            { to: "/dashboard/orders", label: "My Subscription", icon: <AssignmentTurnedInIcon /> },

            showPrepcaConnect && {
                to: "/dashboard/counseling/created",
                label: "Prepca Connect",
                icon: <PeopleAltIcon />
            },

            { to: "/dashboard/download-center", label: "Download", icon: <SimCardDownloadIcon /> },
            { to: "/dashboard/planner", label: "Planner", icon: <CalendarTodayIcon fontSize="small" style={{ marginLeft: 3 }} /> },
            showPrepcaConnect && { to: "/dashboard/practice-mcq", label: "Practice MCQ", icon: <QuizIcon fontSize="small" style={{ marginLeft: 3 }} /> },
            { to: "/dashboard/webinar", label: "Webinar", icon: <VideoCameraFrontIcon fontSize="small" style={{ marginLeft: 3 }} /> },
            { to: "/dashboard/bonuses", label: "Bonuses", icon: <CardGiftcardIcon /> },

        ].filter(Boolean);
    }, [showPrepcaConnect]);

    return (
        <div className={`${classes.left_bar} ${isExtended ? classes.extend : ""}`}>
            <div onClick={handleExtendToggle} className={classes.extend_btn}>
                <ExpandCircleDownIcon />
                <span className={classes.tooltip}>Expand Menu</span>
            </div>

            <div className={classes.menu_list}>
                <ul className={classes.icons_list}>
                    {menuItems.map(({ to, label, icon }) => (
                        <NavLink key={to} to={to}>
                            <li className={isExtended ? "extend" : ""}>
                                {icon}
                                {!isExtended ? <p>{label}</p> : <div>{label}</div>}
                            </li>
                        </NavLink>
                    ))}
                </ul>
            </div>

            <div className={classes.log_out}>
                <ul className={classes.icons_list}>
                    <NavLink to="/logout">
                        <li>
                            <p>Logout</p>
                            <LogoutRoundedIcon />
                            {isExtended && <div>Logout</div>}
                        </li>
                    </NavLink>
                </ul>
            </div>
        </div>
    );
};

export default LeftBar;
